<template><AuthFlow /></template>
<script setup lang="ts">
import AuthFlow from "../../../account/AuthFlow.vue";
</script>
